<label class="radio-button-container" [class.disabled]="disabled">
  <input
    type="radio"
    [name]="name"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onSelectionChange()"
    class="radio-input"
  />
  <span class="radio-circle"></span>
  <span class="radio-label opacity-70">{{ label }}</span>
</label>
